module.exports = __webpack_public_path__ + "img/ky.33156830.svg";